module.exports = __webpack_public_path__ + "img/1548284784.ca56f376.jpg";